import React, { useMemo } from 'react';
const datePlusIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/datePlus.svg';

import * as S from '../../styles';
import { isSameDay } from 'date-fns';

type CalendarScheduleProps = {
  displayDates: Date[];
  selectedDate: Date | null;
  onSelectDate: (date: Date) => void;
  handleClickSeeMore: () => void;
};

export const CalendarSchedule: React.FC<CalendarScheduleProps> = ({
  displayDates,
  selectedDate,
  onSelectDate,
  handleClickSeeMore
}) => {
  const dates = useMemo(() => {
    const dates = displayDates?.slice(0, 3);
    if (selectedDate && !dates.some(date => isSameDay(date, selectedDate))) {
      dates[dates.length - 1] = selectedDate;
    }
    return dates;
  }, [displayDates, selectedDate]);

  return (
    <S.CalendarWrapper>
      <S.TitleCalendar>Datas mais próximas disponíveis</S.TitleCalendar>

      <S.ContainerBlDate>
        {dates.map(date => (
          <S.BlDate
            active={selectedDate ? isSameDay(date, selectedDate) : false}
            onClick={() => onSelectDate(date)}
            key={date.getTime()}
          >
            <S.TitleNumber active={selectedDate ? isSameDay(date, selectedDate) : false}>
              {date.toLocaleDateString('pt-BR', {
                day: '2-digit'
              })}
            </S.TitleNumber>
            <S.DescDate active={selectedDate ? isSameDay(date, selectedDate) : false}>
              {date.toLocaleDateString('pt-BR', { month: 'long' }).slice(0, 3).toUpperCase()}
            </S.DescDate>
          </S.BlDate>
        ))}
        <S.BlDate active={false} onClick={handleClickSeeMore}>
          <S.IconPlusCircle>
            <img src={datePlusIcon} alt="seemore" />
          </S.IconPlusCircle>
          <S.DescDate active={false}>Ver mais</S.DescDate>
        </S.BlDate>
      </S.ContainerBlDate>
    </S.CalendarWrapper>
  );
};
